import { Component, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { DwComponent, DwComponentType, DwMetaDataFormStateService } from '@devwareapps/devware-cap';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppMetaDataItemNames, DocumentItemEntity, DocumentTypeAllItems } from '../../../../meta-data/app-meta-data.service';
import { DocumentsRepositoryService } from '../../services/documents-repository.service';

@DwComponent({
  key: 'document-detail-skeleton',
  name: 'Resource detail loading',
  componentType: DwComponentType.loadingComponent,
  isGlobal: true
})
@Component({
  selector: 'app-document-detail-skeleton',
  host: { '[class.detail-skeleton--embedded]': '!showHeader' },
  template: `
    <section *ngIf="typeLoaded" class="detail-skeleton" role="status" aria-label="Loading resource" aria-busy="true">
      <div class="detail-skeleton__header" *ngIf="showHeader" aria-hidden="true">
        <span class="detail-skeleton__back skeleton"></span>
        <span class="detail-skeleton__title skeleton"></span>
      </div>
      <div class="detail-skeleton__canvas skeleton" *ngIf="interactive">
        <div class="detail-skeleton__toolbar" aria-hidden="true">
          <span></span><span></span><span></span>
        </div>
      </div>
      <div class="detail-skeleton__document" *ngIf="!interactive" aria-hidden="true">
        <div class="detail-skeleton__page">
          <div class="detail-skeleton__page-heading skeleton"></div>
          <div class="detail-skeleton__line skeleton"></div>
          <div class="detail-skeleton__line skeleton"></div>
          <div class="detail-skeleton__line detail-skeleton__line--short skeleton"></div>
          <div class="detail-skeleton__illustration skeleton"></div>
          <div class="detail-skeleton__line skeleton"></div>
          <div class="detail-skeleton__line skeleton"></div>
          <div class="detail-skeleton__line detail-skeleton__line--short skeleton"></div>
        </div>
      </div>
    </section>
  `,
  styleUrls: ['./document-detail-skeleton.component.scss']
})
export class DocumentDetailSkeletonComponent implements OnInit, OnDestroy {
  @Input() showHeader = true;
  @Input() interactive = false;
  typeLoaded = false;
  private lookup?: Subscription;

  constructor(@Optional() private readonly formState: DwMetaDataFormStateService,
    private readonly documents: DocumentsRepositoryService) { }

  ngOnInit(): void {
    // The embedded viewer already knows its type and supplies interactive=true.
    if (!this.showHeader) {
      this.typeLoaded = true;
      return;
    }
    const form = this.formState?.state?.formApi;
    if (form?.item !== AppMetaDataItemNames.DocumentItem) { return; }
    const data = form.getFormData<DocumentItemEntity>();
    if (data?.DocumentTypeId) {
      this.interactive = data.DocumentTypeId === DocumentTypeAllItems.SketchFab3D;
      this.typeLoaded = true;
      return;
    }
    const id = Number(form.keyValue);
    if (!Number.isInteger(id) || id <= 0) { return; }
    this.lookup = this.documents.loadDocumentItem(id).pipe(take(1)).subscribe({
      next: item => {
        this.interactive = item?.DocumentTypeId === DocumentTypeAllItems.SketchFab3D;
        this.typeLoaded = !!item?.DocumentTypeId;
      },
      // The owning form displays load errors; don't reveal an unconfirmed skeleton.
      error: () => this.typeLoaded = false
    });
  }

  ngOnDestroy(): void {
    this.lookup?.unsubscribe();
  }
}
